export const DISCARD_CONFIRM_FROM = 3;
